module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAARVBMVEUAAAD///+AgID///+/v7/Dw8PJycnKysrJycnKysrJycnLy8vKysrKysrKysrJycnJycnLy8vJycnKysrKysrKysrKysqyD17wAAAAFnRSTlMAAQIDDB5HTVFSd3+Hj5aYnbS1zdX12K95HQAAAE5JREFUGNOF0EcOwEAIQ9GZZNJ7+/c/atYGonj5JBAmpa/0rZUBJkMdMBvbgEWpPoA1i5UL2Cux5gFGnT2B+4/8oF8fHOFPDQoFtYPnSF5/OAU/40T7QgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/set_img/icon_go.png
// module id = 255
// module chunks = 1